import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function useWorkerWorkBadgesMaxUi() {
  return useCbhFlag(CbhFeatureFlag.RELEASE_WORKER_WORK_BADGES_MAX_UI, {
    defaultValue: { enabled: false },
  });
}
